export class TipoDocumento {
	id: 1 | 2 | 3;
	descripcion: 'DNI' | 'PASAPORTE' | 'OTROS';

	constructor(data = null) {
		if (data) {
			this.id = data.id;
			this.descripcion = data.descripcion;
		}
	}
}
